// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__37n2R","container":"index_container__2Fi11","btn-forgot":"index_btn-forgot__3scq3","divider":"index_divider__3OE9i","mini-icon":"index_mini-icon__1f1d4"};